<template>
    <div class="alignements-wrapper alignements-container">
        <v-btn fab small color="Gray-700" class="pagination-arrow pagination-arrow-top" @click="scrollToTop"
            :disabled="isAtTop">
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>

        <div class="pa-0 alignements-list-container" ref="scrollContainer" @scroll="handleScroll">
            <v-container v-if="alignementsStore.state.numberOfAlignments === 0"
                class="alignement-card-no-data pa-0 my-10">
                <p v-if="search">
                    Aucun alignement ne correspond aux termes de recherche spécifiés : <span class="font-weight-bold">{{
                        search }}</span>.
                </p>
                <p v-else>
                    Aucun alignement ne correspond aux termes de recherche spécifiés.
                </p>
                <p class="mx-0 mt-5 mb-2">Suggestions :</p>
                <ul>
                    <li>Vérifiez l'orthographe des termes de recherche.</li>
                    <li>Essayer d'autres termes.</li>
                    <li>Utilisez des mots clés plus généraux.</li>
                </ul>
            </v-container>
            <AlignementVignette v-else v-for="item in alignementsStore.state.alignmentsList" :key="item.alignementId"
                :alignment="item" />

            <div v-if="hasMoreAlignments" class="text-center py-4">
                <v-btn fab small color="primary" @click="loadMoreAlignments" style="background-color: var(--primary);">
                    <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
            </div>
        </div>

        <v-btn fab small color="Gray-700" class="pagination-arrow pagination-arrow-bottom" @click="scrollToBottom"
            :disabled="isAtBottom">
            <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
    </div>
</template>

<script>
import AlignmentsStore from "../alignements-store";
import AlignementVignette from "./AlignementVignette";
import ScrollNavigationMixin from "../mixins/scroll-navigation.mixin";

export default {
    name: 'Alignements',

    mixins: [ScrollNavigationMixin],

    components: {
        AlignementVignette
    },

    props: {
        search: String
    },

    data: () => ({
        alignementsStore: AlignmentsStore,
        currentPageNumber: 1
    }),

    computed: {
        /**
         * Indique si des alignements supplémentaires peuvent être chargés.
         * @returns {boolean}
         */
        hasMoreAlignments() {
            return this.alignementsStore.state.alignmentsList.length < this.alignementsStore.state.numberOfAlignments;
        }
    },

    methods: {
        /**
         * Charge la page suivante d'alignements via le store.
         * @returns {void}
         */
        loadMoreAlignments() {
            this.currentPageNumber += 1;
            const endpoint = '/api/alignements/search';
            const params = {
                'searchedText': this.search,
                'pagination': this.currentPageNumber,
                'size': AlignmentsStore.state.itemsPerPage,
                'adv': this.alignementsStore.getExtendedSearch(),
            };

            AlignmentsStore.loadMoreAlignments(endpoint, params);
        },
    }
}
</script>

<style lang="scss" scoped>
.alignements-wrapper {
    position: relative;
    height: 90vh;
    width: 100%;
}

.alignements-list-container {
    height: 100%;
    overflow: auto;
}

.pagination-arrow {
    position: absolute;
    right: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);

    &.pagination-arrow-top {
        top: 10px;
    }

    &.pagination-arrow-bottom {
        bottom: 10px;
    }

    &:disabled {
        opacity: 0.3;
    }
}

.alignement-card-no-data {
    max-width: 700px !important;
}
</style>
